// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	zaraz: '',
	cloudinaryBaseUrl: 'https://res.cloudinary.com/whydonate/image/upload/',
	apiUrl: 'https://whydonate-development.appspot.com/api/v1/',
	ACCOUNT_API_V2: 'https://account-staging.whydonate.dev/',
	ACCOUNTING_API: 'https://accounting-staging.whydonate.dev/',
	DONATION_API_V2: 'https://donation-staging.whydonate.dev/',
	FUNDRAISER_API_V2: 'https://fundraiser-staging.whydonate.dev/',
	CUSTOM_DOMAIN_API_V2: 'https://customdomain-staging.whydonate.dev/',
	homeUrl: 'https://whydonate.in',
	helpDeskUrl: 'https://helpdesk.whydonate.com',
	domain: 'whydonate.in',
	donation_url: 'https://donation-staging.whydonate.dev',
	wallet_url: 'https://wallet-staging.whydonate.dev/',
	project_url: 'https://project-staging.whydonate.dev/',
	search_url: 'https://search-staging.whydonate.dev/',
	fundraiser_url: 'https://fundraiser-staging.whydonate.dev/',
	fundraiser_features_url: 'https://fundraiser-staging.whydonate.dev/',
	ADMIN_API: "https://admin-staging.whydonate.dev",
	PASSWORD_ENCRYPTION_KEY: 'mMNIzrZQuZl01Pas9S4Z/MchYS3y0kkd4+IA0+pJ3Hg=',
	SENTRY_AUTH_TOKEN:
		'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',
	STRIPE_PUBLISHABLE_KEY_EU: 'pk_test_uzkdGj1giwLryrAsw8G3TMGg',
	STRIPE_PUBLISHABLE_KEY_US:
		'pk_test_51MyULDEJyxSpFgVbBV8EHstICwmYVQo7tTpJxztsMyGpgLKUkpfwCVKmoOFF5IWWBRKREAPz0OXAn3cMEou6y3S300ILaIvmwE',
	OFFICIAL_DOMAINS: [
		'whydonate.com',
		'whydonate.in',
		'localhost:4200',
		'whydonate.work',
		'whydonate.cc',
		'main.whydonate-web-portal.pages.dev',
		'master.whydonate-web-portal.pages.dev',
		'develop.whydonate-web-portal.pages.dev',
		'features.whydonate-web-portal.pages.dev',
		'features2.whydonate-web-portal.pages.dev',
	],
};

/** * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
